import { render, staticRenderFns } from "./BaseImagesViewerGroup.vue?vue&type=template&id=2cd8c51e&scoped=true"
import script from "./BaseImagesViewerGroup.vue?vue&type=script&lang=js"
export * from "./BaseImagesViewerGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8c51e",
  null
  
)

export default component.exports